import {Button, Stack, useTheme} from '@mui/material';
import React, {Fragment} from 'react';

import Icon from 'presentation/icons';
import {Row} from 'presentation/components';
import {useContractStatus} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {BankDataProps} from './types';

const {bank} = translations['pt-br'].privateFlow.profile.changeData;
const {change} = translations['pt-br'].commons;

const BankData = ({data, onChange, hiddenChangeAction, isInvalid}: BankDataProps) => {
	const {isValid, isCancelledAtFiveYears} = useContractStatus();
	const theme = useTheme();

	const errorIcon = isInvalid ? (
		<Icon name="error-outline" size={16} color={theme.palette.error.main} />
	) : undefined;

	return (
		<Stack mt={2}>
			<Stack spacing={2}>
				<Fragment>
					<Row.Simple
						title={bank.bankName}
						value={`${data.bank.code} - ${formatText(data.bank.description)}`}
					/>

					<Row.Compound
						items={[
							{
								title: bank.agency,
								value: data.agency,
								icon: errorIcon,
							},
							{
								title: bank.digit,
								value: data?.agencyDigit || '-',
								icon: errorIcon,
							},
						]}
					/>
				</Fragment>

				<Row.Compound
					hiddenDivider
					items={[
						{
							title: bank.account,
							value: data.account,
							icon: errorIcon,
						},
						{
							title: bank.digit,
							value: data.accountDigit || '-',
							icon: errorIcon,
						},
					]}
				/>
			</Stack>
			{!hiddenChangeAction ? (
				<Stack direction="row" justifyContent="flex-end">
					{isValid || isCancelledAtFiveYears ? (
						<Button
							variant="text"
							onClick={onChange}
							data-tag-id={MyProfileEnum.CLICK_ALTERAR_DADOS_BANCARIOS}>
							{change}
						</Button>
					) : null}
				</Stack>
			) : null}
		</Stack>
	);
};

export {BankData};
